/* ============================================================
 * 登出 / token 失效时统一清理所有用户态 store
 *
 * 触发时机：`xuntu:auth-expired` 事件（由 `api/client.ts`
 * 401 拦截器触发，或用户点「退出登录」间接触发）。
 *
 * 范围说明：
 * - profile / message / notice / order / points 均持有**用户态**数据，
 *   登出后必须清，否则下一账号登录会闪现旧账号内容。
 * - home **不调**：首页数据是全平台公开的，跨账号可共享缓存。
 * - auth 自己已监听了 auth-expired 并调 `clear()`，不需要在此重复。
 *
 * 由 `main.ts` 全局事件监听调用，单点入口便于日后扩展。
 * ============================================================ */

import { useMessageStore } from './message'
import { useNoticeStore } from './notice'
import { useOrderStore } from './order'
import { usePointsStore } from './points'
import { useProfileStore } from './profile'

export function resetAllUserStores(): void {
  useProfileStore().reset()
  useMessageStore().reset()
  useNoticeStore().reset()
  useOrderStore().reset()
  usePointsStore().reset()
}